import { TempSharingSettingsType } from './types';

export enum ActionTypes {
  UPDATE_TEMP_SHARING_SETTINGS = 'UPDATE_TEMP_SHARING_SETTINGS',
  RESET_TEMP_SHARING_SETTINGS = 'RESET_TEMP_SHARING_SETTINGS',
}

type UpdateTempSharingSettingsAction = {
  type: ActionTypes.UPDATE_TEMP_SHARING_SETTINGS;
  updateType: TempSharingSettingsType;
  value: string | boolean;
};

type ResetTempSharingSettingsAction = {
  type: ActionTypes.RESET_TEMP_SHARING_SETTINGS;
};

export type TempSharingSettingsAction =
  | UpdateTempSharingSettingsAction
  | ResetTempSharingSettingsAction;
